<template>

<div class="container">
  <div id="content" class="content">
    <div class="join">
      <!-- 페이지 타이틀 -->
      <div class="page-title tit_page">
        <h2 class="tit">비밀번호 변경</h2>
      </div>
      <form id="frm" @submit.prevent="doChange">
        <div class="join_form ">
          <!-- 필수 입력항목 표시는 necessary 클래스 -->
          <div class="form_row">
            <label class="lab" for="password">기존 비밀번호<span> •</span></label>
            <input id="old_password" name="password" type="password" class="inp" placeholder="8자 이상 영문, 숫자 포함" v-model="oldPasswd" required="required">
          </div>
          <div class="form_row">
            <label class="lab" for="password">새 비밀번호<span> •</span></label>
            <input id="password" name="password" type="password" class="inp" placeholder="8자 이상 영문, 숫자 포함" v-model="newPasswd" required="required">
            <p class="error_text" v-show="!$options.filters.isEmpty(newPasswd) && newPasswd.length<8">비밀번호가 8자리 이상이 아닙니다. 다시 입력해 주세요.</p>
          </div>
          <div class="form_row">
            <label class="lab" for="password-check">새 비밀번호 확인<span> •</span></label>
            <input id="password-check" name="password-check" type="password" class="inp" placeholder="비밀번호 확인" v-model="newPasswdChk" required="required">
            <p class="error_text" v-show="!$options.filters.isEmpty(newPasswdChk) && newPasswd !== newPasswdChk">비밀번호가 일치하지 않습니다. 다시 입력해 주세요.</p>
          </div>
        </div>

          <div class="join_button">
            <button type="submit" class="btn btn-lg btn_join">비밀번호 변경</button>
          </div>

      </form>
    </div>
  </div>
</div>



</template>

<script>

export default {
	name: "changePassword",
	props: {

	},
	data () {

		return {
			oldPasswd: "",
			newPasswd: "",
			newPasswdChk: "",
		}
	},
	async created() {
		await !this.requireLogin(this, false)
	},
	mounted() {

	},
	methods: {

		doChange (e) {

			e.preventDefault()

			// const regs = /^[A-Za-z0-9+]{8,20}/
			const regs = this.PASSWORD_REGS;
			if ( !this.stringUtils.isEmpty( this.newPasswd ) && !regs.test( this.newPasswd ) ) {
				this.swalUtils.gritter("새 비밀번호가 짧습니다.", "새로운 비밀번호를 영문과 숫자, 특수문자가 포함된 8 ~ 20자리 사이로 입력해주세요.", "warning", 2000)
				return;
			}

			if ( this.stringUtils.isEmpty( this.oldPasswd ) || this.stringUtils.isEmpty( this.newPasswd ) || this.stringUtils.isEmpty( this.newPasswdChk ) ) {
				this.swalUtils.gritter("비밀번호를 입력해주세요.", "기존 비밀번호와 신규비밀번호, 비밀번호 확인란을 입력해주세요.", "warning", 2000)
				return;
			}

			const self = this
			this.axiosCaller.patch(this, this.APIs.CO_ACCOUNT + "/changePassword", {
				oldPasswd: this.oldPasswd,
				newPasswd: this.newPasswd,
				newPasswdChk: this.newPasswdChk,
			}, (res) => {
				const result = res.data;

				if ( result.status === "ok" ) {
					self.swalUtils.gritter("비밀번호 변경완료", "다음 로그인시 부터 적용됩니다.", "success", 3000 )
					.then(() => {
						location.href = "/mypage/"
					})
				} else {
					console.log(result.msg)
					self.swalUtils.gritter("변경취소", result.msg, "error", 3000 )
				}
			})

		}

	},
	watch: {


	},

}
</script>

<style scoped>

</style>
